module.exports = __webpack_public_path__ + "static/favicon.d719b7ff.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/components/favicon.png
// module id = 1060
// module chunks = 0 1 2 3 4 5 6 7